import CloseIcon from '@mui/icons-material/Close';
import { AppBar, Box, IconButton, List, ListItem, Tab, Tabs, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { SyntheticEvent, useEffect, useState } from 'react';
import { type Observation } from '../../../shared/types';
import { useForecastDays } from '../../hooks/useForecasts';
import { Forecasts } from './Forecasts';
import { Today } from './Today';
import { Yesterday } from './Yesterday';

type Props = {
    showClose?: boolean;
    observation: Observation;
    onClose: () => void;
};

export const ObservationData = ({ showClose = true, observation, onClose }: Props) => {
    const [selectedTab, setSelectedTab] = useState(0);
    const { data: forecastDays = [] } = useForecastDays(observation.station._id.toString());

    const handleTabSelect = (_: SyntheticEvent, tab: number) => {
        setSelectedTab(tab);
    };

    useEffect(() => {
        if (forecastDays.length < 1) {
            setSelectedTab(0);
        }
    }, [forecastDays.length]);

    return (
        <>
            <List sx={(theme) => ({ backgroundColor: theme.palette.background.default, pb: 0 })}>
                <ListItem sx={{ justifyContent: 'space-between', alignItems: 'start' }}>
                    <Box>
                        <Typography variant="h5">{`${observation.station.name}`}</Typography>
                        <Typography variant="subtitle1">{`${observation.station.description}`}</Typography>
                        <Typography variant="caption">{`As of: ${observation.min15.timestamp ? dayjs(observation.min15.timestamp).format('lll') : ''}`}</Typography>
                    </Box>
                    {showClose && (
                        <Box>
                            <IconButton aria-label="close" color="primary" onClick={onClose}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    )}
                </ListItem>
                {/* <Divider />
                <ListItem dense={true}>
                    <Typography variant="h5">{numeral(observation.min15.avgTemp).format('0.0')}&#8457;</Typography>
                </ListItem>
                <ListItem dense={true}>
                    <Typography variant="subtitle1" sx={{ mr: 1 }}>{`High | Low:`}</Typography>
                    <Typography variant="body1" color="error">
                        {numeral(observation.min15.runningMaxTemp).format('0.0')}&#8457;
                    </Typography>
                    <Divider orientation="vertical" flexItem={true} sx={{ ml: 1, mr: 1 }} />
                    <Typography variant="body1" color="info">
                        {numeral(observation.min15.runningMinTemp).format('0.0')}&#8457;
                    </Typography>
                </ListItem>
                <Divider /> */}
            </List>
            <AppBar position="static" sx={(theme) => ({ backgroundColor: theme.palette.grey[100] })}>
                <Tabs value={selectedTab} onChange={handleTabSelect}>
                    <Tab label="Today" id="tab-0" aria-controls="tabpanel-0" value={0} />
                    <Tab label="Yesterday" id="tab-1" aria-controls="tabpanel-1" value={1} />
                    {forecastDays.length > 0 && <Tab label="Forecasts" id="tab-2" aria-controls="tabpanel-2" value={2} />}
                </Tabs>
            </AppBar>
            {selectedTab === 0 && <Today observation={observation} />}
            {selectedTab === 1 && <Yesterday observation={observation} />}
            {selectedTab === 2 && <Forecasts id={observation.station._id.toString()} />}
        </>
    );
};
